module.exports = __webpack_public_path__ + "static/media/login-background.c601cde5.jpg";